<template>
    <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action="#"
        :auto-upload="false"
        :multiple="multiple"
        :limit="multiple ? limit : undefined"
        :accept="accept"
        :disabled="disabled"
        :file-list="fileList"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :on-preview="handlePreview"
    >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
            Arraste e solte o arquivo aqui ou <em>clique para enviar</em>
        </div>
        <div v-if="tipText" class="el-upload__tip" slot="tip">{{ tipText }}</div>
    </el-upload>
</template>

<script>
    import { Upload, Message } from "element-ui"

    export default {
        props: {
            // v-model: File (multiple = false) ou File[] (multiple = true)
            value: {
                type: [Array, Object],
                default: null,
            },
            // Tamanho máximo por arquivo, em MB. 0 = sem limite
            maxSize: {
                type: Number,
                default: 0,
            },
            // Tipos aceitos: extensões e/ou MIME. Ex: ".pdf,.png" ou "image/*,application/pdf"
            accept: {
                type: String,
                default: "",
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            // Quantidade máxima de arquivos (só quando multiple = true)
            limit: {
                type: Number,
                default: undefined,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            tip: {
                type: String,
                default: "",
            },
        },
        computed: {
            files() {
                if (!this.value) return [];
                return Array.isArray(this.value) ? this.value : [this.value];
            },
            // Lista no formato que o el-upload espera, derivada do v-model
            fileList() {
                return this.files.map(file => ({
                    name: file.name,
                    size: file.size,
                    uid: file.uid,
                    raw: file,
                    status: "ready",
                }));
            },
            acceptRules() {
                return this.accept
                    .split(",")
                    .map(rule => rule.trim().toLowerCase())
                    .filter(Boolean);
            },
            tipText() {
                if (this.tip) return this.tip;
                const parts = [];
                if (this.accept) parts.push(`Tipos aceitos: ${this.accept}`);
                if (this.maxSize) parts.push(`tamanho máximo de ${this.maxSize} MB`);
                if (this.multiple && this.limit) parts.push(`até ${this.limit} arquivos`);
                return parts.join(", ");
            },
        },
        methods: {
            isTypeValid(file) {
                if (!this.acceptRules.length) return true;

                const name = file.name.toLowerCase();
                const mime = (file.type || "").toLowerCase();

                return this.acceptRules.some(rule => {
                    if (rule.startsWith(".")) return name.endsWith(rule);
                    if (rule.endsWith("/*")) return mime.startsWith(rule.slice(0, -1));
                    return mime === rule;
                });
            },
            isSizeValid(file) {
                if (!this.maxSize) return true;
                return file.size / 1024 / 1024 <= this.maxSize;
            },
            // Remove da lista interna do el-upload um arquivo que não passou na validação
            discard(file) {
                const list = this.$refs.upload.uploadFiles;
                const index = list.indexOf(file);
                if (index !== -1) list.splice(index, 1);
            },
            emitFiles(files) {
                const value = this.multiple ? files : (files[files.length - 1] || null);
                this.$emit("input", value);
                this.$emit("change", value);
            },
            handleChange(file) {
                if (file.status !== "ready") return;

                const raw = file.raw;

                if (!this.isTypeValid(raw)) {
                    Message.error(`O arquivo "${raw.name}" não é de um tipo aceito (${this.accept}).`);
                    this.discard(file);
                    return;
                }

                if (!this.isSizeValid(raw)) {
                    Message.error(`O arquivo "${raw.name}" passa do limite de ${this.maxSize} MB.`);
                    this.discard(file);
                    return;
                }

                // No modo único, o novo arquivo substitui o anterior
                const files = this.multiple ? [...this.files, raw] : [raw];
                this.emitFiles(files);
            },
            handleRemove(file) {
                const files = this.files.filter(f => f.uid !== file.uid);
                this.emitFiles(files);
            },
            handleExceed() {
                Message.warning(`Você pode enviar no máximo ${this.limit} arquivos.`);
            },
            handlePreview(file) {
                this.$emit("preview", file.raw || file);
            },
        },
        components: {
            [Upload.name]: Upload,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/Form/upload/FormDragAndDropUpload.vue